module.exports = __webpack_public_path__ + "media/images/storage-temp-753aa60fc9e176e36fb50d2b24bce36e.svg";